<template>
  <div class="thumbnail-preview-container w-100">
    <slot name="before-container" :images="images" :args="args" />
    <div v-for="(object, index) in images" :key="index" :class="['thumbnail-preview-wrapper', object.class || '', ($_.isArray(object.files) && object.files.length > 1) || ($_.isArray(object.urls) && object.urls.length > 1) ? 'multiple' : '', parseInt(object.uploaded) == 100 ? 'uploaded' : '']" :data-index="index">
      <slot name="before-wrapper" :images="images" :object="object" :index="index" :args="args" />
      <div class="thumbnail-preview-inner" @click.prevent="handleSelectThumbnail(index)">
        <div class="thumbnail-preview" v-for="(image, indexImage) in listThumbnail(object)" :key="indexImage">
          <slot name="before-preview" :image="image" :index="indexImage" :args="args" />
          <div :class="`img ${size}`">
            <Image :src="srcImage(image, size)" />
          </div>
          <div v-show="object?.status" class="progress-bar-xs progress-bar-animated-alt progress">
            <div :class="`progress-bar ${object?.status}`" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" :style="`width: ${object.uploaded}%`"></div>
          </div>
          <slot name="after-preview" :image="image" :index="indexImage" :args="args" />
        </div>
      </div>
      <slot name="remove" :images="images" :object="object" :index="index" :args="args">
        <a href="#remove" v-if="editable" @click.prevent="removeImage(index)"></a>
      </slot>
      <slot name="after-wrapper" :images="images" :object="object" :index="index" :args="args" />
    </div>
    <slot name="after-container" :images="images" :args="args" />
  </div>
</template>

<script>
import Md5 from 'crypto-js/md5'
import defaultThumbnailImage from '@/../assets/imgs/no-thumbnail.jpg'
let images = new Map()
export default {
  emits: ['change', 'changeValue', 'update:modelValue', 'selected'],
  computed: {
    finalValue() {
      if (this.modelValue !== null) {
        return this.modelValue
      } else if (this.value !== null) {
        return this.value
      }
      return null
    },
    multiple() {
      if (_.isString(this.finalValue) || this.finalValue?.files?.length > 0 || this.finalValue?.urls?.length > 0 || this.finalValue?.items?.length > 0) return false
      return true
    },
    images() {
      let images = this.$util.filter(this.multiple ? this.finalValue : [this.finalValue], ({ item }) => {
        return _.isString(item) || item?.files?.length > 0 || item?.urls?.length > 0 || item?.items?.length > 0
      })
      return this.$util.map(images, ({ item }) => {
        if (_.isString(item)) {
          return { urls: [item] }
        } else {
          return item
        }
      })
    }
  },
  methods: {
    listThumbnail(items) {
      let values = items.files || items.urls || items.items
      return _.isObjectLike(values) ? values : [values]
    },
    srcImage(image) {
      if (image instanceof File || image instanceof Blob) {
        if (image.type.indexOf('image') != -1) {
          let hash = Md5(`${image.lastModified}|${image.size}|${image.type}|${image.webkitRelativePath}|${image.name}`).toString()
          if (!images.has(hash)) {
            images.set(hash, URL.createObjectURL(image))
          }
          return images.get(hash)
        }
      } else if (String(image).length > 0) {
        if (Object.keys(this.$util.options.extension.image).includes(this.$util.getExtensionFromString(image))) {
          if ('URLSearchParams' in window) {
            try {
              let url = new URL(String(image))
              url.searchParams.set('size', 'thumbnail')
              return url.href
            } catch {
              return defaultThumbnailImage
            }
          }
          return String(image)
        }
      }
      return defaultThumbnailImage
    },
    handleSelectThumbnail(index) {
      this.$emit('selected', index)
    },
    removeImage(index) {
      let images = Object.assign(this.images)
      let deleted = null
      Object.entries(images).forEach(([index, value]) => {
        if (_.isString(this.value[index])) {
          images[index] = value.urls[0] || ''
        }
      })

      if (images?.[index]) {
        deleted = Object.assign(images[index])
        delete images[index]
      }

      let values = this.multiple ? images : images[Object.keys(images)[0]]
      this.$emit('change', {
        $el: this.$el,
        values,
        deleted,
        index
      })
      this.$emit('changeValue', values, {
        $el: this.$el,
        deleted: index,
        item: deleted
      })
      this.$emit('update:modelValue', values)
    }
  },
  props: {
    value: {
      type: [Array, Object, String],
      default() {
        return null
      }
    },
    modelValue: {
      type: [Array, Object, String],
      default() {
        return null
      }
    },
    editable: {
      type: Boolean,
      default() {
        return false
      }
    },
    size: {
      type: String,
      default() {
        return 'thumbnail'
      }
    },
    args: {
      type: [Array, Object],
      default() {
        return {}
      }
    }
  }
}
</script>
<style lang="scss">
.thumbnail-preview-container {
  display: flex;
  flex-wrap: wrap;
  &:empty {
    padding: 0 !important;
    margin: 0 !important;
  }
  .progress {
    position: absolute;
    bottom: calc(5px + 5px);
    width: calc(90% - 10px);
    left: calc(5% + 5px);
    z-index: 10;
  }
  .progress-bar {
    &.doing {
      background-color: #f7b924 !important;
    }
    &.success {
      background-color: #3ac47d !important;
    }
    &.error {
      background-color: #d92550 !important;
    }
  }
  .thumbnail-preview-wrapper {
    width: 80px;
    position: relative;
    // &::before {
    //   content: '';
    //   display: block;
    //   padding-top: 100%;
    // }
    .mask,
    input[type='radio'],
    input[type='checkbox'] {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      width: 100%;
      height: 100%;
      z-index: 9;
      cursor: pointer;
      &:checked ~ div .thumbnail-preview {
        border: 3px solid #00a6ff;
      }
    }
    .thumbnail-preview-inner {
      display: flex;
      padding: 5px;
      justify-content: center;
      position: relative;
      aspect-ratio: 1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
    .thumbnail-preview {
      border: 1px solid #dfdfdf;
      border-radius: 8px;
      display: flex;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      justify-content: center;
      overflow: hidden;
      .thumbnail {
        width: 100%;
        height: 100%;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    &.multiple {
      .thumbnail-preview {
        display: none !important;
        width: calc(90% - 10px) !important;
        height: calc(90% - 10px) !important;
        margin: 0 !important;
        position: absolute;
        background: #fff;
        &:nth-child(1) {
          display: flex !important;
          bottom: 5px;
          left: 5px;
          z-index: 3;
        }
        &:nth-child(2) {
          display: flex !important;
          top: 5px;
          right: 5px;
          z-index: 1;
        }
        &:nth-child(3) {
          top: 50%;
          left: 50%;
          transform: translate3d(-50%, -50%, 0);
          display: flex !important;
          z-index: 2;
        }
      }
      .progress {
        width: calc(80% - 10px);
      }
    }
  }
  a[href='#remove'] {
    position: absolute;
    top: -5px;
    right: -5px;
    width: 25px;
    height: 25px;
    background: #fff;
    display: block;
    border: 1px solid #ccc;
    border-radius: 50%;
    display: none;
    z-index: 10;
    &:before,
    &:after {
      position: absolute;
      left: 11px;
      top: 4px;
      content: '';
      height: 15px;
      width: 1px;
      background-color: #333;
    }
    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
  }
  > *:hover {
    a[href='#remove'] {
      display: block;
    }
  }
}
</style>
